module.exports = global["adapter"] = require("-!./adapter.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?adapter!./lib/adapter.js-exposed
// module id = 214
// module chunks = 0